import moment from "moment";

// Get ordinal numbers | 1st, 2nd, 3rd, 4th ...
export function getOrdinal(number) {
	switch (number) {
		case 1:
			return "1st";
		case 2:
			return "2nd";
		case 3:
			return "3rd";
		case 4:
			return "4th";
		default:
			return "Invalid input";
	}
}

// Get the class for the date indicator | either happening, ended, or pending.
export function getClassForDate(data) {
	if (data?.status === "happening") {
		return "event_date_indicator_happening";
	} else if (data?.status === "past") {
		return "event_date_indicator_past";
	} else {
		return "event_date_indicator_pending";
	}
}

//A. Common function to get the date range
const getDateRange = (events, formatFn) => {
	const firstDate = formatFn(events[0]?.startTime);
	const lastDate = formatFn(events[events?.length - 1]?.startTime);
	return firstDate === lastDate ? lastDate : `${firstDate} - ${lastDate}`;
};

//B. Common function to get unique formatted dates
const getUniqueFormattedDates = (events, formatFn) => {
	const uniqueDates = new Map();

	events?.forEach((item) => {
		const formattedDate = formatFn(item?.startTime);

		if (!uniqueDates.has(formattedDate)) {
			uniqueDates.set(formattedDate, {
				date: formattedDate,
				status: item.status,
			});
		}
	});

	return Array.from(uniqueDates.values());
};

//C. Get the current mode of the calendar | either year, week, month, or quarter
//----- using getDateRange & getUniqueFormattedDates functions.
export const modeFormatters = {
	year: {
		dateRange: (events) =>
			getDateRange(events, (date) => moment(date).utc().format("ddd, MMM D")),
		uniqueFormatted: (events) =>
			getUniqueFormattedDates(events, (date) =>
				moment(date).utc().format("DD.MM")
			),
	},

	week: {
		dateRange: (events) =>
			getDateRange(events, (date) => `Week ${moment(date).utc().week()}`),
		uniqueFormatted: (events) =>
			getUniqueFormattedDates(events, (date) => moment(date).utc().week()),
	},

	month: {
		dateRange: (events) =>
			getDateRange(events, (date) => moment(date).utc().format("MMMM")),
		uniqueFormatted: (events) =>
			getUniqueFormattedDates(events, (date) =>
				moment(date).utc().format("MMM")
			),
	},

	quarter: {
		dateRange: (events) =>
			getDateRange(
				events,
				(date) => `${getOrdinal(moment(date).utc().quarter())} Quarter`
			),
		uniqueFormatted: (events) =>
			getUniqueFormattedDates(events, (date) => moment(date).utc().quarter()),
	},
};
